import React, { useEffect, useState } from "react";
import api from "../../api";
import HrLayout from "../HrLayout";

export default function HrDocuments() {
  const [loading, setLoading] = useState(true);
  const [documents, setDocuments] = useState([]);
  const [status, setStatus] = useState("pending");
  const [editDoc, setEditDoc] = useState(null);
  const [remark, setRemark] = useState("");

  // ---------------- Load Documents ----------------
  const loadDocuments = async () => {
    setLoading(true);
    try {
      const res = await api.get(`/hr/documents?status=${status}`);
      setDocuments(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      console.error(err);
      alert("Failed to load documents");
    }
    setLoading(false);
  };

  useEffect(() => {
    loadDocuments();
  }, [status]);

  // ---------------- Approve / Reject ----------------
  const updateStatus = async (newStatus) => {
  if (!editDoc) return;

  if (newStatus === "rejected" && !remark) {
    return alert("Remark is required for rejection");
  }

  // Approved ko verified me convert
  if (newStatus === "approved") newStatus = "verified";

  try {
    await api.put(`/employee/upload/documents/${editDoc.id}/status`, {
      status: newStatus,
      remark,
    });

    setEditDoc(null);
    setRemark("");
    loadDocuments();
  } catch (err) {
    console.error(err);
    alert("Failed to update status");
  }
};


  // ---------------- Status Chip ----------------
  const chip = (status) => {
    if (status === "approved")
      return "bg-emerald-50 text-emerald-700 border-emerald-200";
    if (status === "rejected")
      return "bg-rose-50 text-rose-700 border-rose-200";
    return "bg-amber-50 text-amber-700 border-amber-200";
  };

  return (
    <HrLayout title="HR Documents">
      {/* Header */}
      <div className="flex justify-between mb-5">
        <h1 className="text-2xl font-bold text-slate-800">
          Employee Documents
        </h1>

        <select
          value={status}
          onChange={(e) => setStatus(e.target.value)}
          className="border rounded-lg px-3 py-2 text-sm"
        >
          <option value="pending">Pending</option>
          <option value="approved">Approved</option>
          <option value="rejected">Rejected</option>
          <option value="all">All</option>
        </select>
      </div>

      {/* Table */}
      <div className="bg-white border rounded-xl shadow-sm overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm min-w-[900px]">
            <thead className="bg-slate-100 border-b">
              <tr>
                <Th>Employee</Th>
                <Th>Doc Type</Th>
                <Th>Status</Th>
                <Th>Uploaded</Th>
                <Th className="text-right">Actions</Th>
              </tr>
            </thead>

            <tbody>
              {loading ? (
                Array.from({ length: 5 }).map((_, i) => (
                  <tr key={i}>
                    <Td><Sk /></Td>
                    <Td><Sk /></Td>
                    <Td><Sk /></Td>
                    <Td><Sk /></Td>
                    <Td><Sk /></Td>
                  </tr>
                ))
              ) : documents.length === 0 ? (
                <tr>
                  <Td colSpan={5} className="text-center py-10 text-slate-500">
                    No documents found
                  </Td>
                </tr>
              ) : (
                documents.map((doc) => (
                  <tr key={doc.id} className="border-b hover:bg-slate-50">
                    <Td>
                      <div className="font-semibold">
                        {doc.employee_name}
                      </div>
                    </Td>

                    <Td className="uppercase font-medium">
                      {doc.doc_type}
                    </Td>

                    <Td>
                      <span
                        className={`inline-flex px-2.5 py-1 rounded-full border text-xs font-semibold ${chip(doc.status)}`}
                      >
                        {(doc.status || "pending").toUpperCase()}
                      </span>
                    </Td>

                    <Td>
                      {doc.uploaded_at
                        ? new Date(doc.uploaded_at).toLocaleString()
                        : "—"}
                    </Td>

                    <Td className="text-right">
                      <div className="inline-flex gap-2">
                        {/* ✅ FIXED PREVIEW URL */}
                       <a
                        href={`${process.env.REACT_APP_API_URL}/${doc.file_url}`}
                        target="_blank"
                        rel="noreferrer"
                        className="text-indigo-600 underline"
                      >
                        View
                      </a>

                        {doc.status === "pending" && (
                          <button
                            onClick={() => {
                              setEditDoc(doc);
                              setRemark("");
                            }}
                            className="px-3 py-1.5 rounded-lg bg-indigo-600 text-white text-xs font-semibold"
                          >
                            Verify / Reject
                          </button>
                        )}
                      </div>
                    </Td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* Modal */}
      {editDoc && (
        <Modal title="Update Document Status" onClose={() => setEditDoc(null)}>
          <div className="space-y-3">
            <div className="text-sm font-semibold">
              {editDoc.employee_name} • {editDoc.doc_type}
            </div>

            <textarea
              rows={3}
              placeholder="Remark (required for rejection)"
              value={remark}
              onChange={(e) => setRemark(e.target.value)}
              className="w-full border rounded-lg px-3 py-2 text-sm"
            />

            <div className="flex justify-end gap-2">
              <button
                onClick={() => updateStatus("approved")}
                className="px-4 py-2 bg-emerald-600 text-white rounded-lg"
              >
                Approve
              </button>
              <button
                onClick={() => updateStatus("rejected")}
                className="px-4 py-2 bg-rose-600 text-white rounded-lg"
              >
                Reject
              </button>
              <button
                onClick={() => setEditDoc(null)}
                className="px-4 py-2 border rounded-lg"
              >
                Close
              </button>
            </div>
          </div>
        </Modal>
      )}
    </HrLayout>
  );
}

/* ---------------- Helpers ---------------- */

function Th({ children, className = "" }) {
  return (
    <th className={`px-4 py-3 text-left text-xs font-bold uppercase text-slate-500 ${className}`}>
      {children}
    </th>
  );
}

function Td({ children, className = "", colSpan }) {
  return (
    <td colSpan={colSpan} className={`px-4 py-3 ${className}`}>
      {children}
    </td>
  );
}

function Sk() {
  return <div className="h-4 bg-slate-100 rounded animate-pulse" />;
}

function Modal({ title, children, onClose }) {
  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
      <div className="bg-white w-full max-w-lg rounded-2xl shadow-xl">
        <div className="flex justify-between px-5 py-4 border-b">
          <div className="font-bold">{title}</div>
          <button onClick={onClose}>✕</button>
        </div>
        <div className="p-5">{children}</div>
      </div>
    </div>
  );
}
